import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {StoreDevtoolsModule} from '@ngrx/store-devtools';

import {CoreModule} from './core/core.module';
// Children
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
// Feature Modules
import {LoginModule} from './login/login.module';
import {OrganizationModule} from './organization/organization.module';
import {DashboardModule} from './dashboard/dashboard.module';
import {ReportModule} from './report/report.module';

import 'hammerjs';

@NgModule({
  imports: [
    BrowserModule,
    CoreModule.forRoot(),
    AppRoutingModule,
    LoginModule,
    OrganizationModule,
    DashboardModule,
    ReportModule,
    StoreDevtoolsModule.instrument({
      maxAge: 10 //  Buffers the last 10 states
    })
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent]
})

export class AppModule {
}
